export {
  now,
  timer,
  timerFlush
} from "./timer";

export {
  default as timeout
} from "./timeout";

export {
  default as interval
} from "./interval";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-timer/src/index.js
// module id = 226
// module chunks = 0